export const educationPrograms = [
  {
    id: "corporate",
    title: "Корпоративное обучение ИИ",
    lead: "Корпоративное обучение искусственному интеллекту для компаний, которые хотят системно развивать навыки работы с ИИ внутри команды.",
    description: "Адаптируем программу под задачи компании, функции сотрудников, уровень подготовки команды и требования безопасности. Участники проверяют возможности ИИ на реальных рабочих сценариях.",
    topics: "Работа с документами и данными, исследования, подготовка материалов, автоматизация рутинных задач и создание собственных ИИ-ассистентов.",
    audience: "Команды и подразделения",
    format: "Индивидуальный",
    result: "Рабочие сценарии и навыки применения ИИ",
    cta: "Обсудить программу",
  },
  {
    id: "strategy",
    title: "Стратегическая сессия для топ-команды",
    lead: "Для руководителей, которым важно сформировать общее понимание роли ИИ и выбрать первые направления работы.",
    description: "Разбираем возможности технологий, бизнес-кейсы, процессы компании, ограничения и перспективные инициативы.",
    audience: "Собственники, топ-команда и руководители функций",
    format: "Онлайн или очно",
    result: "Приоритетные направления и следующий шаг",
    cta: "Провести стратсессию",
  },
  {
    id: "personal",
    title: "Личный ИИ",
    lead: "Практические программы для руководителей и специалистов, которые хотят встроить ИИ в свою работу и перейти к более сложным рабочим сценариям.",
    description: "Участники применяют нейросети к своим задачам и процессам, осваивают современные модели, создают скилы, ИИ-помощников и прикладные инструменты для ежедневной работы.",
    audience: "Собственники, руководители и специалисты",
    format: "Очно",
    result: "Собственная рабочая система с ИИ",
    cta: "Узнать подробности",
  },
  {
    id: "agents",
    title: "Практикум по созданию ИИ-агентов",
    lead: "От задачи до собственного работающего ИИ-решения.",
    description: "Участники разбирают рабочий процесс, проектируют логику ИИ-агента и собирают прототип для своей задачи.",
    audience: "Продвинутые команды и внутренние AI-лидеры",
    format: "Интенсив или серия практикумов",
    result: "Работающий прототип и понимание, как его развивать",
    cta: "Подобрать практикум",
  },
] as const;

export const educationSkills = [
  { title: "Работать эффективнее", text: "Применять ИИ для анализа документов и данных, проведения исследований, подготовки материалов и автоматизации рутинных задач." },
  { title: "Находить сильные ИИ-сценарии", text: "Находить точки применения искусственного интеллекта в рабочих процессах и выбирать сценарии, где автоматизация экономит время и повышает качество результата." },
  { title: "Создавать решения", text: "Создавать собственных ИИ-ассистентов, ИИ-агентов и инструменты автоматизации для реальных задач команды." },
];

export const educationAudiences = [
  { title: "Руководители и собственники", text: "Определить, где искусственный интеллект может дать бизнес-эффект, выбрать приоритетные процессы и подготовить план внедрения ИИ.", result: "Единое понимание роли ИИ и следующие шаги", program: "strategy" },
  { title: "Команды и специалисты", text: "Освоить ИИ и нейросети на задачах специалистов и проектных команд, автоматизировать повторяющиеся операции и встроить инструменты в ежедневную работу.", result: "Сценарии для своей функции и навыки работы с ИИ", program: "corporate" },
  { title: "Внутренние AI-лидеры", text: "Проектировать ИИ-агентов, создавать инструменты автоматизации и готовить прикладные ИИ-решения к пилотному запуску.", result: "Прототипы и сценарии для дальнейшего развития", program: "agents" },
];
